<template>
  <div class="GestionCookies">
    <h1>Conditions générales d'utilisation</h1>
    <div class="containerPageCookies">
    <div class="containerCookies">
    <p>

Les présentes conditions générales régissent l’utilisation de ce site lhairderien.fr. <br>
Ce site appartient et est géré par Floriane Cornier et Leatitia Delaye<br>
En utilisant ce site, vous indiquez que vous avez lu et compris les conditions d’utilisation et que vous acceptez de les respecter en tout temps. <br><br>

Type de site : vitrine <br><br>

Propriété intellectuelle <br><br>

Tout contenu publié et mis à disposition sur ce site est la propriété de Floriane Cornier et de ses créateurs. Cela comprend, mais n’est pas limité aux images, textes, logos, documents, fichiers téléchargeables et tout ce qui contribue à la composition de ce site.<br><br>

Utilisation acceptable <br><br>

En tant qu’utilisateur, vous acceptez d’utiliser notre site légalement et de ne pas utiliser ce site pour des fins illicites, à savoir :<br><br>

Violer les droits des autres utilisateurs du site <br>
Violer les droits de propriété intellectuelle des propriétaires du site ou de tout tiers au site <br>
Agir de toute façon qui pourrait être considérée comme frauduleuse <br>
Participer à toute activité illégale sur le site <br>
Afficher tout matériel qui peut être jugé inapproprié ou offensant <br>
Si nous estimons que vous utilisez ce site illégalement ou d’une manière qui viole les conditions d’utilisation acceptable ci-dessus, nous nous réservons le droit de limiter, suspendre ou résilier votre accès à ce site. Nous nous réservons également le droit de prendre toutes les mesures juridiques nécessaires pour vous empêcher d’accéder à notre site. <br><br>

Limitation de responsabilité <br><br>

Floriane Cornier ou l’un de ses employés sera tenu responsable de tout problème découlant de ce site. Néanmoins, Floriane Cornier et ses employés ne seront pas tenus responsables de tout problème découlant de toute utilisation irrégulière de ce site. <br><br>

Indemnité <br><br>

En tant qu’utilisateur, vous indemnisez par les présentes Floriane Cornier de toute responsabilité, de tout coût, de toute cause d’action, de tout dommage ou de toute dépense découlant de votre utilisation de ce site ou de votre violation de l’une des dispositions énoncées dans le présent document. <br><br>

Lois applicables <br><br>

Ce document est soumis aux lois applicables en France et vise à se conformer à ses règles et règlements nécessaires. Cela inclut la réglementation à l’échelle de l’UE énoncée dans le RGPD. <br><br>

Divisibilité <br><br>

Si, à tout moment, l’une des dispositions énoncées dans le présent document est jugée incompatible ou invalide en vertu des lois applicables, ces dispositions seront considérées comme nulles et seront retirées du présent document. Toutes les autres dispositions ne seront pas touchées par les lois et le reste du document sera toujours considéré comme valide. <br><br>

Modifications <br><br>

Ces conditions générales peuvent être modifiées de temps à autre afin de maintenir le respect de la loi et de refléter tout changement à la façon dont nous gérons notre site et la façon dont nous nous attendons à ce que les utilisateurs se comportent sur notre site. Nous recommandons à nos utilisateurs de vérifier ces conditions générales de temps à autre pour s’assurer qu’ils sont informés de toute mise à jour. Au besoin, nous informerons les utilisateurs par courriel des changements apportés à ces conditions ou nous afficherons un avis sur notre site. <br><br>

Contact <br><br>

Veuillez communiquer avec nous si vous avez des questions ou des préoccupations. Nos coordonnées sont les suivantes : <br><br>

09 81 79 47 68 <br><br>

lhairderienmarseille@gmail.com <br><br>

860 Route de la Légion 13400 Aubagne <br><br>

Date d'entrée en vigueur : le 20 août 2022. <br><br>

© 2002-2022, DocumentsLégaux™ (Sequiter Inc.) <br><br>

    </p>
</div>
</div>
  </div>
</template>
<script>
import { defineComponent, computed, reactive } from 'vue'
import { useHead } from '@vueuse/head'
export default defineComponent({
  setup () {
    const siteData = reactive({
      title: "lhairderien - nos conditions générales d'utilisation",
      description: ''
    })
    useHead({
      // Can be static or computed
      title: computed(() => siteData.title),
      meta: [
        {
          name: 'description',
          content: computed(() => siteData.description)
        }
      ]
    })
  }
})
</script>

<style lang="scss" scoped>
.GestionCookies {
    width: 80%;
    float: right;
    background: gray;
    // text-align: center;
    display: flex;
    align-items: center;
    flex-direction: column;
}
.containerCookies {
    background: white;
    width: 90%;
   padding: 20px;
}
p {
    font-size: 18px;
}
.containerPageCookies {
    width: 100%;
    display: flex;
    justify-content: center;
}
@media (max-width:990px) {
  .GestionCookies {
    width: 100%;
  }
}
</style>
